module.exports = __webpack_public_path__ + "img/calendar-lg.9cb95cfc.svg";